export * from './CarouselTextItem';
